<template>
  <div>
    <h1 class="header-style">
      Contractor <br>Check-in
    </h1>
    <br>
    <p class="subheader-style">
      Click <font class="next-text">
        'Next'
      </font> to complete the check-in.
    </p>
    <v-stepper
      v-if="orgSettings.questionnaire_verification"
      v-model="contractorCheckIn"
      light
      class="my-stepper-style"
      elevation="0"
    >
      <v-stepper-header>
        <v-stepper-step
          :complete="contractorCheckIn > 1"
          step="1"
          color="#000"
        />

        <v-divider />

        <v-stepper-step
          :complete="contractorCheckIn > 2"
          step="2"
          color="#000"
        />

        <v-divider />

        <v-stepper-step
          :complete="contractorCheckIn > 3"
          color="#000"
          step="3"
        />

        <v-divider />

        <v-stepper-step
          :complete="contractorCheckIn > 4"
          color="#000"
          step="4"
        />
      </v-stepper-header>
    </v-stepper>
    <v-stepper
      v-if="!orgSettings.questionnaire_verification"
      v-model="contractorCheckIn"
      light
      class="my-stepper-style"
      elevation="0"
    >
      <v-stepper-header>
        <v-stepper-step
          :complete="contractorCheckIn > 1"
          step="1"
          color="#000"
        />

        <v-divider />

        <v-stepper-step
          :complete="contractorCheckIn > 2"
          step="2"
          color="#000"
        />

        <v-divider />

        <v-stepper-step
          :complete="contractorCheckIn > 3"
          color="#000"
          step="3"
        />
      </v-stepper-header>
    </v-stepper>

    <div>
      <contractor-location-verification
        v-if="showLocationVerificationPage"
        :org-settings="orgSettings"
        @verification-completed="toSecondStep"
      />
      <gather-contract-details
        v-if="showContractDetailsPage"
        @contract-details-stored="toThirdStep"
      />
      <contractor-questions
        v-if="showQuestionsPage"
        @questions-answered="toFourthStep"
      />
      <review-contract-details
        v-if="showContractReviewPage"
        @checkin-completed="checkInCompleted"
      />
    </div>
  </div>
</template>
<script>
  import ContractorLocationVerification from '../dialogComponents/ContractorDialogs/checkin/ContractorLocationVerification.vue';
  import GatherContractDetails from '../dialogComponents/ContractorDialogs/checkin/GatherContractDetails.vue';
  import ContractorQandA from '../dialogComponents/ContractorDialogs/checkin/ContractorQandA.vue';
  import ReviewContractDetails from '../dialogComponents/ContractorDialogs/checkin/ReviewContractDetails.vue';

  export default {
    name: 'ContractorCheckInPage',
    components: {
      'contractor-location-verification': ContractorLocationVerification,
      'gather-contract-details': GatherContractDetails,
      'contractor-questions': ContractorQandA,
      'review-contract-details': ReviewContractDetails,
    },
    data () {
      return {
        contractorCheckIn: 1,
        showLocationVerificationPage: false,
        step1SuccessColor: '',
        showContractDetailsPage: false,
        step2SuccessColor: '',
        showQuestionsPage: false,
        step3SuccessColor: '',
        showContractReviewPage: false,
      };
    },
    computed: {
      step1Success () {
        return `color:${this.step1SuccessColor}`;
      },
      step2Success () {
        return `color:${this.step2SuccessColor}`;
      },
      step3Success () {
        return `color:${this.step3SuccessColor}`;
      },
      checkInMethodType () {
        return this.$store.getters['swiftuser/getCheckInMethodType'];
      },
      selectedOrganization () {
        return this.$store.getters['organization/getSelectedOrganization'];
      },
      orgSettings () {
        return this.$store.getters['organization/getOrganizationSettings'];
      },
    },
    mounted () {
      this.loadOnMount();
      this.fetchOrgDetails();
      this.checkSettingsLocation();
    },
    methods: {
      checkSettingsLocation () {
        this.userCheckIn = 1;
        this.showLocationVerificationPage = true;
        this.showQuestionsPage = false;
        this.showContractReviewPage = false;
        this.showContractDetailsPage = false;
      },
      checkSettingsQuestionnaire () {
        if (!this.orgSettings.questionnaire_verification) {
          this.showQuestionsPage = false;
          this.showContractReviewPage = true;
          this.userCheckIn = 3;
        }
      },
      loadOnMount () {
        if (this.checkInMethodType === null || Object.keys(this.selectedOrganization).length === 0) {
          this.$router.push({ name: 'CheckIn' });
        }
      },
      async fetchOrgDetails () {
        await this.$store.dispatch('organization/fetchOrganizationSettings', this.selectedOrganization);
      },
      toSecondStep () {
        this.step1SuccessColor = '#00796B';
        this.contractorCheckIn = 2;
        this.showLocationVerificationPage = false;
        this.showQuestionsPage = false;
        this.showContractReviewPage = false;
        this.showContractDetailsPage = true;
      },
      toThirdStep () {
        this.step2SuccessColor = '#00796B';
        this.contractorCheckIn = 3;
        this.showLocationVerificationPage = false;
        this.showContractReviewPage = false;
        this.showContractDetailsPage = false;
        this.showQuestionsPage = true;
        this.checkSettingsQuestionnaire();
      },
      toFourthStep () {
        this.step3SuccessColor = '#00796B';
        this.contractorCheckIn = 4;
        this.showLocationVerificationPage = false;
        this.showReviewJobPage = false;
        this.showContractDetailsPage = false;
        this.showQuestionsPage = false;
        this.showContractReviewPage = true;
      },
      checkInCompleted () {
        this.$router.push({ name: 'Checkin Success' });
      },
    },
  };
</script>
